import { render, staticRenderFns } from "./dialogOrderInfoForWX.vue?vue&type=template&id=88e731ce&scoped=true"
import script from "./dialogOrderInfoForWX.vue?vue&type=script&lang=js"
export * from "./dialogOrderInfoForWX.vue?vue&type=script&lang=js"
import style0 from "./dialogOrderInfoForWX.vue?vue&type=style&index=0&id=88e731ce&prod&lang=less&scoped=true"
import style1 from "./dialogOrderInfoForWX.vue?vue&type=style&index=1&id=88e731ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e731ce",
  null
  
)

export default component.exports